import { render, staticRenderFns } from "./DashboardEmailLog.vue?vue&type=template&id=3fd4f07a&scoped=true"
import script from "./DashboardEmailLog.vue?vue&type=script&lang=js"
export * from "./DashboardEmailLog.vue?vue&type=script&lang=js"
import style0 from "./DashboardEmailLog.vue?vue&type=style&index=0&id=3fd4f07a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd4f07a",
  null
  
)

export default component.exports